/**
 * Messaging permission keys (docs/contracts/messaging.md §5). The API checks the same keys; provider accounts, templates
 * and segments keep the legacy `platform.sms_*` keys (MS2, MS3, MS4), the newer screens use `msg.*`.
 */
export const msgPermissions = {
  outgoingView: "msg.outgoing_message.view",
  outgoingResend: "msg.outgoing_message.resend",
  incomingView: "msg.incoming_message.view",
  templateView: "platform.sms_template.view",
  templateUpdate: "platform.sms_template.update",
  accountView: "platform.sms_config.view",
  accountUpdate: "platform.sms_config.update",
  triggerView: "msg.trigger.view",
  triggerUpdate: "msg.trigger.update",
  consentView: "msg.consent.view",
  consentUpdate: "msg.consent.update",
  segmentView: "platform.sms_group.view",
  segmentUpdate: "platform.sms_group.update",
  bulkSend: "msg.bulk.send",
  bulkApprove: "msg.bulk.approve",
  surveyView: "msg.survey.view",
  documentSend: "msg.document.send",
} as const;

/** Plan module of Messaging (always on; SMS and WhatsApp also need their plan flags, MS8). */
export const msgModule = "msg";
